export enum EnumIndPres {
    NAO_SE_APLICA = 0,
    PRESENCIAL = 1,
    NAO_PRESENCIAL_INTERNET = 2,
    NAO_PRESENCIAL_TELEATENDIMENTO = 3,
    ENTREGA_DOMICILIO = 4,
    PRESENCIAL_FORA = 5,
    NAO_PRESENCIAL_OUTROS = 9,
}